"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyCustomTransfer = void 0;
const verifyTransferLeg_1 = require("./verifyTransferLeg");
const verifyCustomTransfer = (legs) => {
    if (!(0, verifyTransferLeg_1.verifyTransferLeg)(legs.outbound))
        return false;
    if (!(0, verifyTransferLeg_1.verifyTransferLeg)(legs.inbound))
        return false;
    return true;
};
exports.verifyCustomTransfer = verifyCustomTransfer;
